export const generateSessionOrderId = () => {
  const dateAndTimeNow = Date.now();
  return dateAndTimeNow + generateRandomHexValue(20);
};
const generateRandomHexValue = (size) =>
  [...Array(size)]
    .map(() => Math.floor(Math.random() * 16).toString(16))
    .join('');
